import React from 'react';
import PropTypes from 'prop-types';
import AttributeMenu from './attribute_menu';


export default class FilterLogicalSelector extends AttributeMenu {
    renderMenu() {
        const {onSelect, styles} = this.props;
        return (
            <>
                <h5>Select an Operator</h5>
                <ul className="filter-list w-list-unstyled" style={styles}>
                    <li className="filter-item" onClick={() => onSelect("and")}>
                        <strong>and</strong>
                    </li>
                    <li className="filter-item" onClick={() => onSelect("or")}>
                        <strong>or</strong>
                    </li>
                </ul>
            </>
        );
    }
}

FilterLogicalSelector.propTypes = {
    onSelect: PropTypes.func.isRequired,
    styles: PropTypes.object,
};

FilterLogicalSelector.defaultProps = {
    styles: {},
};
